import { ID } from "@/types/common"

/**
 * 用户状态枚举
 */
export enum UserStatus {
  /** 激活 */
  ACTIVE = "ACTIVE",
  /** 未激活 */
  INACTIVE = "INACTIVE",
}

/**
 * 用户实体接口
 * API 返回/页面表格展示的完整用户实体
 */
export interface User {
  /** 用户ID */
  id: ID
  /** 用户编码 */
  code: string
  /** 用户名 */
  name: string
  /** 头像URL */
  avatar?: string
  /** 用户状态 */
  status: UserStatus
  /** 角色ID列表 */
  roleIds?: ID[]
  /** 角色名称列表（用于展示） */
  roleNames?: string[]
  /** 创建时间 */
  createdAt?: string
  /** 更新时间 */
  updatedAt?: string
}

/**
 * 用户表单数据接口
 * 表单提交用的数据结构
 */
export interface UserFormData {
  /** 用户编码 */
  code: string
  /** 用户名 */
  name: string
  /** 头像URL */
  avatar?: string
  /** 用户状态（更新时可选） */
  status?: UserStatus
  /** 角色ID列表 */
  roleIds?: ID[]
}

/**
 * 用户表格组件属性接口
 */
export interface UserTableProps {
  /** 用户列表数据 */
  users: User[]
  /** 编辑用户回调函数 */
  onEdit: (user: User) => void
  /** 删除用户回调函数 */
  onDelete: (id: User["id"]) => void
  /** 加载状态 */
  loading?: boolean
  /** 已选中的用户ID列表 */
  selectedIds?: Array<User["id"]>
  /** 选择变化回调函数 */
  onSelectionChange?: (selectedIds: Array<User["id"]>) => void
}

/**
 * 用户信息弹窗组件属性接口
 */
export interface UserModalProps {
  /** 弹窗是否打开 */
  isOpen: boolean
  /** 当前编辑的用户信息，为null时表示新增 */
  user: User | null
  /** 提交加载状态 */
  loading: boolean
  /** 关闭回调函数 */
  onClose: () => void
  /** 保存回调函数 */
  onSave: (data: UserFormData) => void
  /** 角色列表（用于选择） */
  roles?: Array<{ id: ID; name: string; code: string }>
}
